import {
    Component,
    OnInit,
    AfterViewChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    NgZone,
    Inject
} from '@angular/core';
import { ShoppingcartService } from '../shoppingcart.service';
import { Material } from '../material';
import { Product } from '../product';
import { Router } from '@angular/router';
import { LanguageService } from '../../language/language.service';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { RemovepackagepopupComponent } from '../removepackagepopup/removepackagepopup.component';
import { GoogleTagManagerService } from '../../google-tag-manager/google-tag-manager.service';
import { ProductList } from '../cartsummary/productList';
import { DeliveryOption } from '../typeofdelivery/deliveryoptions';
import { ApiRequestService } from '../../shared/api-request-service';
import { ToastmessageService } from '../../toastmessage/toastmessage.service';
import { GetDeliveryOptionsResponse } from '../typeofdelivery/getdeliveryoptionsresponse';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'pw-cartsum',
    templateUrl: './cartsum.component.html',
    styleUrls: ['./cartsum.component.scss']
})
export class CartsumComponent implements OnInit, AfterViewChecked {
    totalQuantity = 0;
    totalPrice = 0;
    materials: Material[] = [];
    product: Product[] = [];
    hasPreorder = false;
    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    //TODO user can choose if he/she wants to get preordered product together or separately
    separated = false;

    hasPreOrder = false;

    hasChosenSeparation = false;

    chooseSeparationMessage = '';

    separatedOption = '';

    isExtraSmall: Observable<BreakpointState>;

    doesCartHaveDiscountLimitedUntilProduct = false;

    discountLimititedUntilMaterials: Material[] = [];

    getFreeDeliveryAllowedDeliveryoptionsUrl = '/order/get-free-delivery-options';

    deliveryOptionsFreeList: DeliveryOption[] = [];

    orderBaseUrl = '';

    constructor(
        private _matDialog: MatDialog,
        private router: Router,
        private _shoppingCartService: ShoppingcartService,
        private _router: Router,
        private _languageService: LanguageService,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private readonly breakpointObserver: BreakpointObserver,
        private _googleTagManagerService: GoogleTagManagerService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService
    ) {
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);

        this.orderBaseUrl = _orderBackendUrl;
    }

    ngAfterViewChecked(): void {
        if (this.materials.length > 0) {
            this.ngZone.runOutsideAngular(() => {
                this.ref.detectChanges();
                setTimeout(() => {
                    const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                    const totalPrice = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
                    if (this.materials.length !== materials.length || this.totalPrice != totalPrice) {
                        this.materials = materials;
                        this.doesCartHaveDiscountLimitedUntilProduct = this.doesCartIncludesDiscountLimitedUntilMaterial(this.materials);
                        this.generateDiscountLimitedUntilMaterialsList();
                        this.materials.forEach((material) => {
                            if (material.hasPreorder) {
                                this.hasPreOrder = true;
                            }
                        });
                        this.calculateTotalPriceAndTotalQuantity();
                        this.updateShoppingcartStatus();
                    }
                }, 0);
            });
        }
        if (this.materials.length === 0) {
            this.ngZone.runOutsideAngular(() => {
                this.ref.detectChanges();
                setTimeout(() => {
                    this.router.navigateByUrl('/');
                }, 0);
            });
        }
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('separatedOption')) {
            sessionStorage.removeItem('separatedOption');
        }

        if (sessionStorage.getItem('separated')) {
            sessionStorage.removeItem('separated');
        }
        if (sessionStorage.getItem('materials')) {
            this.materials = this._shoppingCartService.getItems();
            //this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        } else {
            this.materials = this._shoppingCartService.getItems();
        }
        this.doesCartHaveDiscountLimitedUntilProduct = this.doesCartIncludesDiscountLimitedUntilMaterial(this.materials);
        this.generateDiscountLimitedUntilMaterialsList();
        this.calculateTotalPriceAndTotalQuantity();
        this.updateShoppingcartStatus();

        this._googleTagManagerService.viewCart(this.materials);

        this.getFreeDeliveryOptions();
    }

        getFreeDeliveryOptions() {
            this._apiRequestService
                .sendRequest<{}, GetDeliveryOptionsResponse>(this.orderBaseUrl, true, {}, true, this.getFreeDeliveryAllowedDeliveryoptionsUrl)
                .subscribe((response: GetDeliveryOptionsResponse) => {
                    this.deliveryOptionsFreeList = response.deliveryOptionsList as DeliveryOption[];
                });
        }

    generateDiscountLimitedUntilMaterialsList() {
        const discountMaterialArray: Material[] = [];
        if (this.doesCartHaveDiscountLimitedUntilProduct) {
            this.materials.forEach((material) => {
                if (material.discountLimitedUntil != null) {
                    discountMaterialArray.push(material);
                }
            })
            this.discountLimititedUntilMaterials = [...discountMaterialArray];
        }
    }

    doesCartIncludesDiscountLimitedUntilMaterial(materials: Material[]): boolean {
        return materials.some(material => material.discountLimitedUntil !== null);
    }

    calculateTotalPriceAndTotalQuantity() {
        this._shoppingCartService.calculateTotalPrice();
        this.materials.forEach((material) => {
            this.totalQuantity += material.quantity as number;
            this.totalPrice += (material.originalPrice as number) * material.quantity!;
        });
    }
    updateShoppingcartStatus() {
        const totalPrice: number = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        const totalQuantity: number = JSON.parse(sessionStorage.getItem('totalQuantity') as string) as number;
        this.totalPrice = totalPrice;
        this.totalQuantity = totalQuantity;
    }
    removeItem(material: Material) {
        const totalPrice: number = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        if (totalPrice > 0) {
            if (!material.packageName) {
                material.quantityOfSupply! += material.quantity!;
                material.quantity = 0;
                this._shoppingCartService.removeItem(material);
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                this.materials = materials;
                this.updateShoppingcartStatus();
                window.location.reload();

                //googleTagManager remove method is in shoppingCartService
            }
            if (material.packageName) {
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                let packageItemList: Material[] = [];

                materials.forEach((materialObject) => {
                    if (materialObject.packageName === material.packageName) {
                        packageItemList.push(materialObject);
                    }
                });

                this._googleTagManagerService.removePackageFromCart(packageItemList);

                materials.forEach((materialObject) => {
                    if (materialObject.packageName === material.packageName) {
                        materialObject.quantityOfSupply! += materialObject.quantity!;
                        materialObject.quantity = 0;
                        this._shoppingCartService.removeItem(materialObject);
                        const materialList = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                        this.materials = materialList;
                        this.updateShoppingcartStatus();
                        window.location.reload();
                    }
                });
            }
        }
    }
    increaseItemQuantity(material: Material) {
        this._shoppingCartService.increaseItemQuantity(material);
        this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        this.updateShoppingcartStatus();
    }

    decreaseItemQuantity(material: Material) {
        this._shoppingCartService.decreaseItemQuantity(material);
        this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        this.updateShoppingcartStatus();
    }

    goToContact() {
        if (this.hasChosenSeparation || !this.hasMaterialPreorder() || this.materials.length === 1) {
            this.collectShoppingcartDetails();
            //this.generateMaterialList();
        } else {
            this.chooseSeparationMessage = 'Kérem válasszon rendelési opciót!';
        }
    }

    collectShoppingcartDetails() {
        this.materials.forEach((value) => {
            let product: Product = {
                productId: value.id,
                quantity: value.quantity,
                packageName: value.packageName,
                price: value.originalPrice,
                isPreorder: value.hasPreorder,
                available: value.available
            };
            this.product.push(product);
        });

        sessionStorage.setItem('orderProduct', JSON.stringify(this.product));

        if (!this.hasMaterialPreorder() || this.materials.length === 1) {
            sessionStorage.setItem('separated', JSON.stringify(false));
        } else {
            sessionStorage.setItem('separated', JSON.stringify(this.separated));
        }

        this._shoppingCartService.order = {
            product: this.product,
            totalPriceOfBooks: this.totalPrice,
            language: this._languageService.actualLanguage,
            separated: this.separated
        };

        sessionStorage.setItem('language', JSON.stringify(this._shoppingCartService.order.language));
        sessionStorage.setItem('totalPriceOfBooks', JSON.stringify(this._shoppingCartService.order.totalPriceOfBooks));

        this._router.navigateByUrl('/contact');
    }

    loadRemovePackagePopup(selectedMaterial: Material, enterAnimationDuration: string, exitAnimationDuration: string) {
        this.dialogConfiger.data = selectedMaterial;
        const popupDialog = this._matDialog.open(RemovepackagepopupComponent, {
            data: selectedMaterial,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw'
        });
        const smallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '70vh');
            } else {
                popupDialog.updateSize('calc(50% - 50px)', '');
            }
        });
        popupDialog.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
        });
    }

    clickOnUnSeparated() {
        this.separated = false;
        this.hasChosenSeparation = true;
        this.separatedOption = 'UNSEPARATED';
        sessionStorage.setItem('separatedOption', JSON.stringify(this.separatedOption));
        //essionStorage.setItem('separated', JSON.stringify(this.separated));
    }

    clickOnSeparated() {
        this.separated = true;
        this.hasChosenSeparation = true;
        this.separatedOption = 'SEPARATED';
        sessionStorage.setItem('separatedOption', JSON.stringify(this.separatedOption));
        //sessionStorage.setItem('separated', JSON.stringify(this.separated));
    }

    removeDuplicateElementsFromPreorderMaterial(material: any, key: string) {
        const seen = new Map();
        const result = [];

        for (const item of material) {
            const keyValue = item[key];

            if (!seen.has(keyValue)) {
                seen.set(keyValue, true);
                result.push(item);
            }
        }

        return result;
    }

    hasMaterialPreorder(): boolean {
        let hasPreorder = false;
        this.materials.forEach((material) => {
            if (material.hasPreorder) {
                hasPreorder = true;
            }
        });
        return hasPreorder;
    }
}
